import Vue from 'vue';
export default Vue.extend({
    props: {
        fluid: {
            type: Boolean,
            default: false
        },
        narrow: {
            type: Boolean,
            default: false
        }
    }
});
